import multiple_attachments from './multiple-attachments'
import _bundle from "../../core/core--bundles";
import attachment_grid from "./attachment-grid";

export default function () {
    //Initialize Attachments
    init();

    //Add to bundle PageUpdate event
    _bundle.add({
        name: 'Initialize Attachments',
        event: ['on:PageUpdate'],
        fn() {
            init();
        }
    });
}

const init = () => {
    multiple_attachments();
    attachment_grid($('.js-attachment-grid'));
}